import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const useDeleteDocumentTemplate = () => { 
  const queryClient = useQueryClient();
  return useMutation(
    params => {  
      return axios.delete(`${apiSitePrefix}/documenttemplates/delete/${params.oldRecord.documentTemplateUuid}`)
    },
    {
      onMutate: async (record) => {
        let key = ['DocumentTemplates'];
        if (record.extraKeys) {
          key = [
            ...key,
            ...record.extraKeys
          ]
        }

        const removeRecord = record.oldRecord;
        await queryClient.cancelQueries(key)
        const previousData = queryClient.getQueryData(key);    
        queryClient.setQueryData(key, oldData => { 
          return oldData.filter(oldRecord => {
            return (oldRecord.documentTemplateUuid !== removeRecord.documentTemplateUuid);
          })
        });
        const options = { previousData, key };
        return options;
      },
      onSuccess: (rec, variables, options) => {
        const { key } = options;
        queryClient.invalidateQueries(key);
        queryClient.getQueryCache().queries.filter(
          (query)=>{
            return query.queryKey[0] === key[0] && query.queryKey[query.queryKey.length - 1] === '_cached'
          }
        ).forEach(cache => {
          queryClient.resetQueries(cache.queryKey, true)
        });        

        if (variables.resolve) variables.resolve(rec);
        if (variables.postSuccess) variables.postSuccess({ key, record: rec, status: "SUCCESS" });
      },
      onError: (err, variables, options) => {
        const { key, previousData } = options;
        queryClient.setQueryData(key, previousData);
        queryClient.invalidateQueries(key);
        queryClient.getQueryCache().queries.filter(
          (query)=>{
            return query.queryKey[0] === key[0] && query.queryKey[query.queryKey.length - 1] === '_cached'
          }
        ).forEach(cache => {
          queryClient.resetQueries(cache.queryKey, true)
        });        

        if (variables.reject) variables.reject(err);
        if (variables.postError) variables.postError({ key, status: "ERROR", errorMessage: err?.response?.data?.errorMessage });
      }
    }
  )
};

export default useDeleteDocumentTemplate;